import { useState, useEffect } from "react";
import { decode } from "universal-base64";
import clsx from "clsx";

import {
  createAlignPlugin,
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_H4,
  ELEMENT_H5,
  ELEMENT_H6,
  ELEMENT_PARAGRAPH,
  ELEMENT_LI,
  createPlugins,
  createParagraphPlugin,
  createBlockquotePlugin,
  createTodoListPlugin,
  createHeadingPlugin,
  createImagePlugin,
  createHorizontalRulePlugin,
  createLinkPlugin,
  createListPlugin,
  createTablePlugin,
  createMediaEmbedPlugin,
  createCodeBlockPlugin,
  createBoldPlugin,
  createCodePlugin,
  createItalicPlugin,
  createHighlightPlugin,
  createUnderlinePlugin,
  createStrikethroughPlugin,
  createSubscriptPlugin,
  createSuperscriptPlugin,
  createFontBackgroundColorPlugin,
  createFontColorPlugin,
  createFontSizePlugin,
  createFontWeightPlugin,
  createKbdPlugin,
  createNodeIdPlugin,
  createComboboxPlugin,
  createMentionPlugin,
  createDeserializeMdPlugin,
  createDeserializeCsvPlugin,
  createDeserializeDocxPlugin,
  createFontFamilyPlugin,
  createIndentPlugin,
  createPlateEditor,
  serializeHtml,
  createPlateUI,
} from "@udecode/plate";

const option1 = [
  {
    type: "p",
    children: [
      {
        text: "Minute details here ...",
      },
    ],
  },
];

const option2 = [
  {
    type: "p",
    children: [
      {
        text: "",
      },
    ],
  },
];

function deepEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
}

function isObject(object) {
  return object != null && typeof object === "object";
}

function EditorHTMLSmall({ value }) {
  const [initialState, setInitialState] = useState();
  let components = createPlateUI();

  const plugins = createPlugins(
    [
      createParagraphPlugin(),
      createBlockquotePlugin(),
      createTodoListPlugin(),
      createHeadingPlugin(),
      createImagePlugin(),
      createHorizontalRulePlugin(),
      createLinkPlugin(),
      createListPlugin(),
      createTablePlugin(),
      createMediaEmbedPlugin(),
      createCodeBlockPlugin(),
      createBoldPlugin(),
      createCodePlugin(),
      createItalicPlugin(),
      createHighlightPlugin(),
      createUnderlinePlugin(),
      createStrikethroughPlugin(),
      createSubscriptPlugin(),
      createSuperscriptPlugin(),
      createFontBackgroundColorPlugin(),
      createFontFamilyPlugin(),
      createFontColorPlugin(),
      createFontSizePlugin(),
      createFontWeightPlugin(),
      createKbdPlugin(),
      createNodeIdPlugin(),
      createComboboxPlugin(),
      createMentionPlugin(),
      createDeserializeMdPlugin(),
      createDeserializeCsvPlugin(),
      createDeserializeDocxPlugin(),
      // createJuicePlugin(),
      createAlignPlugin({
        inject: {
          props: {
            validTypes: [
              ELEMENT_PARAGRAPH,
              ELEMENT_H1,
              ELEMENT_H2,
              ELEMENT_H3,
              ELEMENT_H4,
              ELEMENT_H5,
              ELEMENT_H6,
            ],
          },
        },
      }),
      createIndentPlugin({
        inject: {
          props: {
            validTypes: [ELEMENT_PARAGRAPH, ELEMENT_H1, ELEMENT_LI],
          },
        },
      }),
    ],
    {
      components,
    }
  );
  const serializeEditor = createPlateEditor({ plugins });

  useEffect(() => {
    if (value) {
      try {
        const decoded = decode(value);
        const tempSerialized = serializeHtml(serializeEditor, {
          nodes: JSON.parse(decoded),
        });
        setInitialState(tempSerialized.replace(/class="[^"]*"/g, ""));
      } catch (error) {
        const tempSerializedAgain = serializeHtml(serializeEditor, {
          nodes: JSON.parse(value),
        });
        setInitialState(tempSerializedAgain.replace(/class="[^"]*"/g, ""));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={clsx(
        "max-w-none",
        "prose-sm",
        "prose-p:!py-0 prose-p:!m-0",
        "prose-figure:m-0",
        "prose-hr:border-t prose-hr:border-black/80 prose-hr:!border-solid",
        "prose-table:!table-auto",
        "prose-table:!border prose-table:!border-black",
        "prose-tr:!border-y prose-tr:!border-black",
        "prose-td:!border-x prose-td:!border-black"
      )}
    >
      {initialState && (
        <div dangerouslySetInnerHTML={{ __html: initialState }}></div>
      )}
    </div>
  );
}

export default EditorHTMLSmall;
